import { Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class LettersOnlyValidator {
  constructor() {}

  lettersOnlyValidator(
    formField: AbstractControl
  ): { [key: string]: any } | null | void {
    // Check if field is Required
    const isEmpty = (formField.value === '') || (formField.value === null) || (formField.value === undefined);
    // console.log('isEmpty: ', isEmpty);
    // if (isEmpty) {
    //   return { required: { valid: false, value: formField.value } };
    // }

    // Must only be letters
    const isAllLetters = /^[a-zA-Z\-'\s]+$/.test(formField.value);
    // console.log('isAllLetters: ', isAllLetters);
    if (!isEmpty && !isAllLetters) {
      return { notAllLetters: { valid: false, value: formField.value } };
    }
  }
}
